import { render, staticRenderFns } from "./SalesTrackerIndustryCrmPage.vue?vue&type=template&id=4aac791c&"
import script from "./SalesTrackerIndustryCrmPage.vue?vue&type=script&lang=js&"
export * from "./SalesTrackerIndustryCrmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports